import {
  Traveler,
  PassengerCounts,
  Offer,
  OfferType,
  OfferSubType,
  Cart,
  FlowConceptData,
} from '@flysas-tech/book-value-stream-models';
import { Array, Object, Optional, Static, String, Boolean, Any } from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils';
import { CartOfferMutationType } from '../../sas-domain';

export type AddRevenueJourneysToCartPayload = Static<typeof AddRevenueJourneysToCartPayload>;
export const AddRevenueJourneysToCartPayload = Object({
  cartId: String(),
  offerId: String(),
  outboundProductId: String(),
  inboundProductId: Optional(String()),
  passengerCounts: PassengerCounts,
});

export type AddAncillariesToCartPayload = Static<typeof AddAncillariesToCartPayload>;
export const AddAncillariesToCartPayload = Object({
  offers: Array(Offer),
});

export type AddRevenueTravelersToCartPayload = Static<typeof AddRevenueTravelersToCartPayload>;
export const AddRevenueTravelersToCartPayload = Object({
  cartId: String(),
  travelers: Array(Traveler),
  needAssistance: Boolean(),
});

export type OfferChange = Static<typeof OfferChange>;
export const OfferChange = Object({
  type: StringEnumSchema(OfferType),
  subType: Optional(StringEnumSchema(OfferSubType)),
  mutationType: StringEnumSchema(CartOfferMutationType),
});

export type ValidateCartResponse = Static<typeof ValidateCartResponse>;
export const ValidateCartResponse = Object({
  cart: Cart,
  ancillaryOffers: Optional(Any()), // Optional(AncillaryOffersResponse) TODO this breaks ..
  offerChanges: Array(OfferChange),
});

export type AddFlowConceptDataPayload = Static<typeof AddFlowConceptDataPayload>;
export const AddFlowConceptDataPayload = Object({
  flowConceptData: FlowConceptData,
});
